import { render, staticRenderFns } from "./CarInsuranceUnRenewedDataTable.vue?vue&type=template&id=db5cf316&scoped=true"
import script from "./CarInsuranceUnRenewedDataTable.vue?vue&type=script&lang=js"
export * from "./CarInsuranceUnRenewedDataTable.vue?vue&type=script&lang=js"
import style0 from "./CarInsuranceUnRenewedDataTable.vue?vue&type=style&index=0&id=db5cf316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5cf316",
  null
  
)

export default component.exports